"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var csx_1 = require("csx");
exports.getTextAttributes = function (textStyle) { return kTextAttributes[textStyle]; };
exports.getFontSize = function (textStyle) { return exports.getTextAttributes(textStyle).fontSize + "px"; };
exports.getTextCSS = function (textStyle) {
    var _a = exports.getTextAttributes(textStyle), fontSize = _a.fontSize, fontWeight = _a.fontWeight, textTransform = _a.textTransform;
    return {
        fontSize: csx_1.px(fontSize),
        fontWeight: fontWeight,
        textTransform: textTransform,
    };
};
exports.getLinkReset = function () {
    return ({
        textDecoration: 'none',
        color: 'inherit',
    });
};
var kFontWeights = {
    regular: 400,
    bold: 600,
};
var kTextAttributes = {
    display: {
        fontSize: 48,
        fontWeight: kFontWeights.bold,
    },
    title1: {
        fontSize: 20,
        fontWeight: kFontWeights.bold,
    },
    title2: {
        fontSize: 20,
        fontWeight: kFontWeights.regular,
    },
    button: {
        fontSize: 14,
        fontWeight: kFontWeights.bold,
    },
    label: {
        fontSize: 14,
        fontWeight: kFontWeights.bold,
        textTransform: 'uppercase',
    },
    body: {
        fontSize: 14,
        fontWeight: kFontWeights.regular,
    },
    mini: {
        fontSize: 12,
        fontWeight: kFontWeights.regular,
    },
    stamp: {
        fontSize: 12,
        fontWeight: kFontWeights.regular,
        textTransform: 'uppercase',
    },
};
